import { observer }            from 'mobx-react';
import { Col }                 from 'antd';
import Row                     from 'components/App/Row';
import Space                   from 'components/App/Space';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import ShowModel               from 'models/ShowModel';
import dayjs                   from 'dayjs';

interface InformationsDatesProps {
  show: ShowModel;
}

const InformationsDates = ({ show }: InformationsDatesProps) => (
  <Row>
    <Col span={24}>
      <Space size={12}>
        <span className="subtitle">
          <FormattedMessageWrapper id="Date limite envoi" />
        </span>

        <table>
          <tbody>
            <tr>
              <td>
                <small>
                  <FormattedMessageWrapper id="Le" />
                </small>
              </td>
              <td style={{ textAlign: 'center' }}>
                {dayjs(show.organizerDeadline).format('DD/MM/YYYY')}
                <br />
                {dayjs(show.organizerDeadline).format('HH[h]mm')}
              </td>
              <td style={{ textAlign: 'center' }}>({dayjs(show.organizerDeadline).fromNow()})</td>
            </tr>
          </tbody>
        </table>

        <span className="subtitle">
          <FormattedMessageWrapper id="Montage" />
        </span>

        <table>
          <tbody>
            <tr>
              <td>
                <small>
                  <FormattedMessageWrapper id="Du" />
                </small>
              </td>
              <td style={{ textAlign: 'center' }}>
                {dayjs(show.installationDateStart).format('DD/MM/YYYY')}
                <br />
                {dayjs(show.installationDateStart).format('HH[h]mm')}
              </td>
              <td>
                <small>
                  <FormattedMessageWrapper id="Au" />
                </small>
              </td>
              <td style={{ textAlign: 'center' }}>
                {dayjs(show.installationDateEnd).format('DD/MM/YYYY')}
                <br />
                {dayjs(show.installationDateEnd).format('HH[h]mm')}
              </td>
            </tr>
          </tbody>
        </table>

        <span className="subtitle">
          <FormattedMessageWrapper id="Démontage" />
        </span>

        <table>
          <tbody>
            <tr>
              <td>
                <small>
                  <FormattedMessageWrapper id="Du" />
                </small>
              </td>
              <td style={{ textAlign: 'center' }}>
                {dayjs(show.uninstallationDateStart).format('DD/MM/YYYY')}
                <br />
                {dayjs(show.uninstallationDateStart).format('HH[h]mm')}
              </td>
              <td>
                <small>
                  <FormattedMessageWrapper id="Au" />
                </small>
              </td>
              <td style={{ textAlign: 'center' }}>
                {dayjs(show.uninstallationDateEnd).format('DD/MM/YYYY')}
                <br />
                {dayjs(show.uninstallationDateEnd).format('HH[h]mm')}
              </td>
            </tr>
          </tbody>
        </table>
      </Space>
    </Col>
  </Row>
);

const InformationsDatesObserver = observer(InformationsDates);

export default InformationsDatesObserver;
